import { render, staticRenderFns } from "./ChangeIconText.vue?vue&type=template&id=5109ffe4&scoped=true"
import script from "./ChangeIconText.vue?vue&type=script&lang=js"
export * from "./ChangeIconText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109ffe4",
  null
  
)

export default component.exports